export const smoothScrollToElement = (element: Element) => {
  if (typeof window.jQuery === 'function') {
    const top = element.getBoundingClientRect().top + window.scrollY - 0;
    window.jQuery!('html, body').animate({ scrollTop: top }, 500);
  } else element.scrollIntoView({ behavior: 'smooth' });
};
